import React from 'react';

export default function KirokuInput(props) {
    return <input {...props} className={`form-control-kiroku ${props.className}`}/>;
}
